export const REGISTERED_CONSULTANT_EVENT = 'registerConsultant';
